import IconBase from "./IconBase";

const DiagonalBarsIcon = props => (
  <IconBase {...props}>
    <g fill="currentColor" fillRule="evenodd" transform="translate(2 2)">
      <rect
        transform="rotate(-45 2.342 2.342)"
        x="-.408"
        y="1.342"
        width="5.5"
        height="2"
        rx="1"
      />
      <rect
        transform="rotate(-45 5.17 5.17)"
        x="-1.58"
        y="4.17"
        width="13.5"
        height="2"
        rx="1"
      />
      <rect
        transform="rotate(-45 7.999 7.999)"
        x="-2.751"
        y="6.999"
        width="21.5"
        height="2"
        rx="1"
      />
      <rect
        transform="rotate(-45 10.827 10.827)"
        x="4.077"
        y="9.827"
        width="13.5"
        height="2"
        rx="1"
      />
      <rect
        transform="rotate(-45 13.655 13.655)"
        x="10.905"
        y="12.655"
        width="5.5"
        height="2"
        rx="1"
      />
    </g>
  </IconBase>
);

export default DiagonalBarsIcon;
